// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers/index.js"
import "./navigation.js"
import "./rough-notation.js"
import "./expired-events.js"
import "./spray-blots.js"
import "./places-map.js"
import "./cookies-bar.js"

// AOS - Animate on Scroll
// Import je v aos_controller.js, který je součástí Stimulus controllers
import AOS from "aos"

document.addEventListener("turbo:load", () => {
  AOS.refreshHard()
})
